import { render } from "./userpage.vue?vue&type=template&id=2b1caf22&scoped=true"
import script from "./userpage.vue?vue&type=script&lang=js"
export * from "./userpage.vue?vue&type=script&lang=js"

import "./userpage.vue?vue&type=style&index=0&id=2b1caf22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1caf22"]])

export default __exports__